import { Injectable } from '@angular/core';

import { map } from 'rxjs';
import { ApiService } from 'src/app/_core/_services/api.service';

@Injectable({
  providedIn: 'root'
})
export class PortalManagementCustomersService {
  constructor(private api: ApiService) {}

  getPortalCustomers(queryParams?: any) {
    if (queryParams) {
      queryParams = {
        ...queryParams
      };
    } else {
      queryParams = {
        limit: 100,
        offset: 0,
        q: '',
        filter: []
      };
    }
    return this.api.getAPI('portal/management/customers', queryParams).pipe(
      map((res: any) => {
        return res.body;
      })
    );
  }

  getPortalCustomerById(portalCustomerId: number) {
    return this.api.getAPI(`portal/management/customers/${portalCustomerId}`).pipe(
      map((res: any) => {
        return res.body;
      })
    );
  }

  updatePortalCustomerContactDetails(portalCustomerId: number, data: any) {
    return this.api
      .patchAPI(`portal/management/customers/${portalCustomerId}/contact-details`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  deletePortalCustomer(portalCustomerId: number) {
    return this.api.deleteAPI('portal/management/customers', portalCustomerId).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  enablePortalCustomer(portalCustomerId: number) {
    return this.api.postAPI(`portal/management/customers/${portalCustomerId}/enable`, {}).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getBenningtonCustomerLookup(query: string) {
    const isEmail = query.includes('@');
    const payload = isEmail ? { email: query } : { voucher_code: query };
    return this.api
      .postAPI('portal/management/benington/customer-lookup', payload)
      .pipe(map((res: any) => res.body));
  }

  resetBenningtonCustomerPassword(email: string, password: string) {
    return this.api
      .postAPI('portal/management/benington/reset-customer-password', { email, password })
      .pipe(map((res: any) => res.body));
  }
}
